import React from 'react';
import './Rightpalltable.css';



const Rightpalltable = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Disha Plastic Pallets Injection Molding Production</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Size</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Material</strong></p>
                    <p><strong>Screw Diameter</strong></p>

                </div>
                <div className="right-column">
                    <p>	DP2000-S6A</p>
                    <p>	Nine-legged Plastic Pallet</p>
                    <p>	1200*1000*150mm</p>
                    <p>8.5KG</p>
                    <p>PE</p>
                    <p>Φ170mm</p>
                </div>
            </div>
        </div>
    );
};

export default Rightpalltable;
